import ProductivityRankingRequests from '../../server/productivityRanking';
import { addLoading, removeLoading } from './loading';

export const setUserBranches = (userBranches) => ({
  type: 'SET_PRODUCTIVITY_RANKING_USER_BRANCHES',
  userBranches,
});

export const setChartsPanel = (chartsPanel) => ({
  type: 'SET_PRODUCTIVITY_RANKING_CHARTS',
  chartsPanel,
});

export const setSelectedBranches = (selectedBranches) => ({
  type: 'SET_PRODUCTIVITY_RANKING_SELECTED_BRANCHES',
  selectedBranches,
});

export const setDates = (dates) => ({
  type: 'SET_PRODUCTIVITY_RANKING_DATES',
  dates,
});

export const setPickingRankings = (pickingRankings) => ({
  type: 'SET_PICKING_RANKINGS',
  pickingRankings,
});

export const setConferenceRankings = (conferenceRankings) => ({
  type: 'SET_CONFERENCE_RANKINGS',
  conferenceRankings,
});

export const setStorageRankings = (storageRankings) => ({
  type: 'SET_STORAGE_RANKINGS',
  storageRankings,
});

export const getUsersForRankings = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await ProductivityRankingRequests.getUsersForRankings();
  } finally {
    dispatch(removeLoading());
  }
};

export const setSelectedUserBranches = (selectedBranches) => async (dispatch) => {
  dispatch(setSelectedBranches(selectedBranches));
};

export const setDashboardOutboundOrdersDates = (dates) => async (dispatch) => {
  dispatch(setDates(dates));
};

export const setDashboardInboundOrdersDates = (dates) => async (dispatch) => {
  dispatch(setDates(dates));
};

export const getExpeditionDashboardInfo = (
  startDate,
  endDate,
  getCharts,
  selectedBranches,
  selectedOrderTypes,
  selectedUsers,
  typeDashboard,
) => async (dispatch) => {
  dispatch(addLoading());
  try {
    const expeditionProductivityRankingDashboardInfo = await ProductivityRankingRequests.getExpeditionDashboardInfo(
      startDate,
      endDate,
      getCharts,
      selectedBranches,
      selectedOrderTypes,
      selectedUsers,
      typeDashboard,
    );
    dispatch(setUserBranches(expeditionProductivityRankingDashboardInfo.userBranches));
    dispatch(setChartsPanel(expeditionProductivityRankingDashboardInfo.charts));
    dispatch(setPickingRankings(expeditionProductivityRankingDashboardInfo.pickingRankings));
    dispatch(setConferenceRankings(expeditionProductivityRankingDashboardInfo.conferenceRankings));
  } finally {
    dispatch(removeLoading());
  }
};

export const getReceiptDashboardInfo = (
  startDate,
  endDate,
  getCharts,
  selectedBranches,
  selectedOrderTypes,
  selectedUsers,
  typeDashboard,
) => async (dispatch) => {
  dispatch(addLoading());
  try {
    const receiptProductivityRankingDashboardInfo = await ProductivityRankingRequests.getReceiptDashboardInfo(
      startDate,
      endDate,
      getCharts,
      selectedBranches,
      selectedOrderTypes,
      selectedUsers,
      typeDashboard,
    );
    dispatch(setUserBranches(receiptProductivityRankingDashboardInfo.userBranches));
    dispatch(setChartsPanel(receiptProductivityRankingDashboardInfo.charts));
    dispatch(setConferenceRankings(receiptProductivityRankingDashboardInfo.conferenceRankings));
    dispatch(setStorageRankings(receiptProductivityRankingDashboardInfo.storageRankings));
  } finally {
    dispatch(removeLoading());
  }
};
